export class UCUMUnit {
    static IU = new UCUMUnit('[IU]');
    static MG_IU = new UCUMUnit('mg/[IU]');
    static ML = new UCUMUnit('mL');
    static ML_LOWER = new UCUMUnit('mL', 'app_mobile', 'units.lowercase.mL');
    static MG_ML = new UCUMUnit('mg/mL');
    static MG_ML_LOWER = new UCUMUnit('mg/mL', 'app_mobile', 'units.lowercase.mg/mL');
    static UG = new UCUMUnit('ug');
    static UL = new UCUMUnit('uL');
    static G = new UCUMUnit('g');
    static MG = new UCUMUnit('mg');
    static CL = new UCUMUnit('cL');
    static L = new UCUMUnit('L');
    static U = new UCUMUnit('U');
    static MG_U = new UCUMUnit('mg/U');
    static OTHER = new UCUMUnit('other');
    static UNKNOWN = new UCUMUnit('unknown', 'app_dashboard', 'dss.allergies.unknown');
    static CENTIMETER = new UCUMUnit('cm');
    static KILOGRAM = new UCUMUnit('kg');
    static KILOGRAM_PER_SQUARE_METER = new UCUMUnit('kg/m²');
    static KILOGRAM_PER_CUBE_METER = new UCUMUnit('kg/m3');
    static MILLIGRAM_PER_DECILITER = new UCUMUnit('mg/dL');
    static MILLIMETER_OF_MERCURY = new UCUMUnit('mm[Hg]');
    static MILLIMOLE_PER_LITER = new UCUMUnit('mmol/L');
    static MILLIMOLE_PER_MOLE = new UCUMUnit('mmol/mol');
    static PERCENT = new UCUMUnit('%');
    static BPM = new UCUMUnit('{beats}/min');

    static CODES = {
        '[IU]' : this.IU,
        'mg/[IU]' : this.MG_IU,
        'mL' : this.ML,
        'mg/mL' : this.MG_ML,
        'ug' : this.UG,
        'uL' : this.UL,
        'g' : this.G,
        'mg' : this.MG,
        'cL' : this.CL,
        'L' : this.L,
        'U' : this.U,
        'mg/U' : this.MG_U,
        'other' : this.OTHER,
        'unknown' : this.UNKNOWN,
        'cm' : this.CENTIMETER,
        'kg' : this.KILOGRAM,
        'kg/m2' : this.KILOGRAM_PER_SQUARE_METER,
        'kg/m3' : this.KILOGRAM_PER_CUBE_METER,
        'mg/dL' : this.MILLIGRAM_PER_DECILITER,
        'mm[Hg]' : this.MILLIMETER_OF_MERCURY,
        'mmol/L' : this.MILLIMOLE_PER_LITER,
        'mmol/mol' : this.MILLIMOLE_PER_MOLE,
        '%' : this.PERCENT,
        '{beats}/min' : this.BPM,
    }

    static FromCode(code){
        return UCUMUnit.CODES[code] ? UCUMUnit.CODES[code] : new UCUMUnit(code);
    }

    /**
     * Constructor
     *
     * @constructs
     * @date
     * @author
     * @copyright UniWeb bvba 2022
     *
     * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
     *
     * @coropreventionSW [SW-4.11] app/src/helper/UCUMUnit.js
     * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
     *
     * @param unit
     * @param catalog
     * @param key
     */
    constructor(unit, catalog = 'app_mobile', key = null) {
        this.unit = unit;
        this.key = key ?? 'units.' + this.updateDoseCodeTranslationIfNeeded();
        this.catalog = catalog;
    }

    /**
     * This is needed to be same as mobile
     * @returns {*}
     */
    updateDoseCodeTranslationIfNeeded = () => {
        // We don't need mappings for now
        switch (this.unit) {
            // Need to use strings here as class is still constructing
            //  case '[IU]':
            default:
                return this.unit;
        }
    }

    /**
     * Translator helper
     * @param $t Translator interface
     * @returns {*}
     */
    translate = ($t) => {
        return $t(this.key, {catalog: this.catalog});
    }

    /**
     *
     * @param $t Translator interface
     * @param label
     * @param unit
     * @returns {{text, value}}
     */
    static generateTranslationLabelValueObjectWithCatalog = ($t, label = "label", unit = null) => {
        return {
            [label]: $t(unit.key, {catalog: unit.catalog}),
            value: unit.unit
        };
    }

    /**
     *
     * @param translator
     * @param label
     * @param units UCUMUnits
     * @returns {{value: *}}
     */
    static generateTranslationLabelValueObjectsWithCatalogForUnits = (translator, label = "label", ...units) => {
        let labelValueObjectsWithCatalog = [];
        units.forEach((unit) => {
            labelValueObjectsWithCatalog.push(this.generateTranslationLabelValueObjectWithCatalog(translator, label, unit));
        });

        return labelValueObjectsWithCatalog;
    }

    toString() {
        return this.unit;
    }
}